import { Link } from "react-router-dom";
import { FaLinkedin, FaGithub, FaFacebook } from "react-icons/fa";
import logo from "./../../logo.jpg";
import "./footer.css";

function Footer() {
  return (
    <footer>
      <div className="container foot">
        <Link className="brand" to="/">
          <img src={logo} className="mark" alt="Devtechinvento logo" />
          <span>Devtechinvento<small>© 2026 Gayan N. Wimalarathna</small></span>
        </Link>
        <div className="foot-links">
          <Link to="/resume">Résumé</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <a href="https://www.devtechinvento.com">www.devtechinvento.com</a>
          <a href="#" className="termly-display-preferences">Consent Preferences</a>
        </div>
        <div className="socials">
          <a href="https://www.linkedin.com/in/gayanwimalarathna/" target="_blank" rel="noopener noreferrer" title="LinkedIn">
            <FaLinkedin size={18} />
          </a>
          <a href="https://github.com/gayanishakaraw" target="_blank" rel="noopener noreferrer" title="GitHub">
            <FaGithub size={18} />
          </a>
          <a href="https://www.facebook.com/people/Dev-Tech-Invento/100089934815888/" target="_blank" rel="noopener noreferrer" title="Facebook">
            <FaFacebook size={18} />
          </a>
        </div>
      </div>
      <div className="copy">© 2026 Devtechinvento · Gayan N. Wimalarathna</div>
    </footer>
  );
}

export default Footer;
